import {
  Button,
  Flex,
  Error,
  ErrorHeadline,
  ErrorDescription,
  WarningIcon,
} from '@frontend/components';
import { failedLanguage } from '@frontend/partviewer/src/ui/Language';

export const ProcessingFailedScreen = () => {
  return (
    <Flex h="100%" align="center" justify="center">
      <Error
        bg="page.surface"
        p={5}
        border="1px solid"
        borderColor="separator.border"
        borderRadius="lg"
        size="lg"
      >
        <WarningIcon color="alert.error" />
        <ErrorHeadline>{failedLanguage.headlineForPart}</ErrorHeadline>
        <ErrorDescription>{failedLanguage.descriptionForPart}</ErrorDescription>
        <Button
          ml={1}
          variant="link"
          as="a"
          href={failedLanguage.helpUrl}
          rel="noopener noreferrer"
          target="_blank"
          display="inline"
        >
          Learn more
        </Button>
      </Error>
    </Flex>
  );
};
